module.exports = {"id":"s4-q3-q4","text":"How often do you access the internet for any reason?","multiselect":false,"next":"s5-q1","options":[{"id":"s4-q3-a1","text":"Less than once a month","capability":-3,"access":-2},{"id":"s4-q3-a2","text":"Two or three times a month","capability":-2,"access":-2},{"id":"s4-q3-a3","text":"Every week","capability":0,"access":0},{"id":"s4-q3-a4","text":"Most days","capability":1,"access":1},{"id":"s4-q3-a5","text":"Every day","capability":1,"access":2},{"id":"s4-q3-a6","text":"Multiple times a day","capability":2,"access":2}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s4-q3.json
// module id = 907
// module chunks = 41